import type { DramaArticle } from "@/types/content";

export const dramas: DramaArticle[] = [
  {
    id: "drama-1",
    title: "主线剧情：一场婚姻的裂痕与重建",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20film%20still%20of%20an%20empty%20modern%20apartment%20living%20room%20at%20dusk%2C%20muted%20navy%20and%20warm%20grey%20tones%2C%20soft%20dramatic%20window%20light%2C%20two%20coffee%20cups%20on%20a%20table%2C%20shallow%20depth%20of%20field%2C%20atmospheric%20haze%2C%20professional%20composition&width=1200&height=750&seq=iwm-drama-01&orientation=landscape",
    summary:
      "十二年的婚姻像一间被雨水浸透的房子，外表完好，内里早已潮湿。林素妍与丈夫李在勋在一次寻常的争吵后，第一次认真审视彼此的距离。",
    content: [
      "《我妻子的一切》选择从一个极其平常的清晨切入：早餐桌上没有人说话，牛奶杯被推开又拉回，报纸的翻页声成了这段婚姻里最响亮的声音。编剧用大量留白告诉观众，真正的危机往往不是激烈的爆发，而是长久的沉默。",
      "林素妍曾经是一名前途可期的舞台剧编剧，为了家庭放弃了创作。她把所有的情绪折叠进日常的琐碎里，直到某一天，她在整理旧物时翻出了一封没有寄出的信，那是一段尘封往事的入口。",
      "李在勋是人人称道的建筑师，理性、可靠，却习惯用「解决问题」的方式对待感情。他以为自己足够了解妻子，却在婚后第十二年第一次意识到，他记住的是她的习惯，而不是她本人。",
      "主线围绕两人在秘密、误解与重新认识之间的往复推进。所谓「我妻子的一切」，既是丈夫想要重新了解妻子的过程，也是妻子找回自我的旅程。",
    ],
    tags: ["家庭矛盾", "婚姻", "情感"],
    year: "2023",
    author: "编辑部 · 顾清和",
    date: "2023-11-02",
    readTime: "9 分钟",
  },
  {
    id: "drama-2",
    title: "开篇解析：看似完美的中产生活",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20film%20still%20of%20a%20clean%20upper%20middle%20class%20kitchen%20in%20early%20morning%2C%20muted%20navy%20and%20ivory%20tones%2C%20soft%20natural%20light%20through%20sheer%20curtains%2C%20minimal%20furnishings%2C%20quiet%20melancholy%20mood%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=1200&height=750&seq=iwm-drama-02&orientation=landscape",
    summary:
      "剧集前两集用近乎冷静的镜头语言，搭建起一个「什么都有、却什么都缺」的中产家庭。《我妻子的一切》的高级感，来自它对日常的精准观察。",
    content: [
      "导演在前两集几乎没有使用任何煽情的配乐，取而代之的是冰箱的嗡鸣、水龙头滴水、电梯到达的提示音。这些环境音构成了家庭生活的底色，也让观众不自觉地进入一种「屏住呼吸」的观看状态。",
      "镜头反复在同一个空间里切换机位：餐桌、玄关、阳台。同一个家被拍出了陌生感，暗示这个家庭看似完整，实则每个人都在自己的轨道上独自行走。",
      "值得注意的是服装与物品的细节设计。素妍的毛衣永远是同一件，而在勋的西装每天都不一样——视觉上已经完成了一次关于「付出」与「被看见」的对比。",
      "开篇埋下的伏笔多达七处，其中三处在第八集才得到呼应。这种耐心，是《我妻子的一切》与普通家庭剧拉开差距的关键。",
    ],
    tags: ["家庭矛盾", "都市", "解析"],
    year: "2023",
    author: "编辑部 · 沈砚",
    date: "2023-11-05",
    readTime: "7 分钟",
  },
  {
    id: "drama-3",
    title: "中段转折：真相浮出水面的那一夜",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20film%20still%20of%20a%20rainy%20night%20street%20with%20wet%20asphalt%20reflecting%20street%20lamps%2C%20deep%20navy%20and%20orange%20accent%20tones%2C%20lonely%20figure%20with%20umbrella%20in%20distance%2C%20atmospheric%20film%20noir%20mood%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=1200&height=750&seq=iwm-drama-03&orientation=landscape",
    summary:
      "第七集结尾的那通电话，是全剧的分水岭。一个被刻意隐藏了十二年的秘密，在一场暴雨里被彻底揭开。",
    content: [
      "转折点的铺垫早在前六集就已完成：反复出现的旧钥匙、素妍母亲欲言又止的电话、以及那份被锁在抽屉里的毕业册。观众以为这些都是情绪的注脚，直到第七集才明白它们都是拼图。",
      "导演用了一个长达两分钟的长镜头完成这场戏。没有对白，只有雨声和素妍慢慢变红的眼眶。这个镜头被不少观众称为「全剧最残忍也最温柔的两分钟」。",
      "真相并不指向背叛，而是指向一段被牺牲的人生。素妍为了成全家庭放弃了舞台，而这段放弃并没有被任何人正式地道歉或感谢过。",
      "从这一集开始，剧集的叙事重心从「丈夫寻找妻子」转向「妻子重新寻找自己」，也奠定了后半程的基调。",
    ],
    tags: ["悬疑", "转折", "解析"],
    year: "2023",
    author: "编辑部 · 顾清和",
    date: "2023-11-12",
    readTime: "8 分钟",
  },
  {
    id: "drama-4",
    title: "结局解读：和解，还是重新开始",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20film%20still%20of%20an%20empty%20theater%20stage%20with%20a%20single%20spotlight%2C%20muted%20navy%20and%20amber%20tones%2C%20dust%20in%20the%20light%20beam%2C%20red%20theater%20seats%20in%20shadow%2C%20emotional%20hopeful%20mood%2C%20high%20detail%2C%20professional%20composition&width=1200&height=750&seq=iwm-drama-04&orientation=landscape",
    summary:
      "大结局没有给出廉价的团圆。它让两个人在清晨的车站相遇，把选择权交还给观众，也交还给角色自己。",
    content: [
      "编剧在最后两集做了减法：没有激烈的争吵，没有痛哭流涕的道歉，也没有「从此幸福地生活在一起」的字幕。素妍独自完成了一场小剧场的剧本朗读，台下只有寥寥十几个人，其中一个是坐在最后一排的在勋。",
      "这个结局之所以动人，是因为它承认了一件事：修复不是回到从前，而是接受彼此已经改变。在勋终于明白，爱一个人不是替她决定人生，而是看着她做自己。",
      "尾声的最后一个镜头停在素妍的手上——那封信被她写下又留白。留白不是逃避，而是把未来的可能性留给了两个人。",
      "可以说，《我妻子的一切》用一个克制的结局，完成了对「婚姻」这一命题最诚实的一次讨论。",
    ],
    tags: ["结局", "情感", "深度解读"],
    year: "2023",
    author: "编辑部 · 沈砚",
    date: "2023-11-26",
    readTime: "10 分钟",
  },
  {
    id: "drama-5",
    title: "支线剧情：老宅里被遗忘的秘密",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20film%20still%20of%20an%20old%20traditional%20korean%20style%20house%20courtyard%20at%20twilight%2C%20muted%20navy%20and%20sepia%20tones%2C%20aged%20wooden%20door%20and%20stone%20path%2C%20soft%20warm%20lantern%20light%2C%20nostalgic%20atmospheric%20mood%2C%20high%20detail&width=1200&height=750&seq=iwm-drama-05&orientation=landscape",
    summary:
      "素妍母亲老宅里的那面墙，藏着两代女性共同的沉默。这条支线看似旁逸斜出，却让主线的情感有了纵深。",
    content: [
      "老宅支线在第九集到第十一集展开。母亲郑美子每次回到老宅都会在同一个位置停留几秒，这个小动作在前八集出现过四次，观众一度以为是演员的即兴发挥。",
      "直到素妍在那面墙里找到母亲年轻时的日记，两条女性命运线才真正交汇：母亲也曾在婚姻里放弃过什么，只是她从未说出口。",
      "支线也解释了素妍性格中「隐忍」的来源——她学会了母亲处理情绪的方式，把委屈层层包裹，直到自己也认不出内心真实的形状。",
      "这条支线让剧集从「一个家庭的矛盾」上升到「两代女性的处境」，格局一下子被打开了。",
    ],
    tags: ["悬疑", "家庭", "支线"],
    year: "2023",
    author: "编辑部 · 林知夏",
    date: "2023-11-19",
    readTime: "6 分钟",
  },
  {
    id: "drama-6",
    title: "时间线梳理：十二年婚姻的关键节点",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20film%20still%20of%20a%20wall%20covered%20with%20old%20family%20photographs%20and%20a%20calendar%2C%20muted%20navy%20and%20ivory%20tones%2C%20soft%20window%20light%2C%20documentary%20research%20mood%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=1200&height=750&seq=iwm-drama-06&orientation=landscape",
    summary:
      "从相识到分居，剧集用十二年丈量了一段感情的重量。我们把散落在十六集里的时间线索，重新拼成一条完整的时间轴。",
    content: [
      "2011 年秋天，两人在大学剧社第一次合作，素妍写剧本，在勋做舞台设计。这一年的戏份全部以暖色调呈现，是全剧唯一的「黄金时代」。",
      "2015 年，素妍放弃了剧团的邀约，两人结婚。婚礼当天，母亲的一个眼神被镜头特写，这是全剧第一次出现「沉默的信号」。",
      "2018 年，在勋事业上升期，素妍的日记在这一年出现第一次空白。编剧用日记的留白，替代了激烈的冲突呈现。",
      "2020 到 2022 年，孩子出生、老宅拆迁、朋友离散，三条线交织叠加，婚姻的疲惫感被推到顶点。",
      "2023 年秋天，故事回到剧集开始的那个清晨。十二年一个循环，但这一次，有人决定不再重复。",
    ],
    tags: ["时间线", "梳理", "资料"],
    year: "2023",
    author: "编辑部 · 顾清和",
    date: "2023-11-30",
    readTime: "11 分钟",
  },
];